import React, { Component } from "react";
import { connect } from "react-redux";
import RemoveUrlTab from "../../components/DashboardSettings/RemoveUrlTab";
import { isDeletingTrackedWebsite, getSelectedWebsiteUrl } from "../../store/tracked_websites/selectors";
import { deleteTrackedWebsite } from "../../store/tracked_websites/operations";

export class RemoveUrl extends Component {
  constructor(props) {
    super(props);

    this.removeTrackedWebsite = this.removeTrackedWebsite.bind(this);
  }

  removeTrackedWebsite() {
    this.props.deleteTrackedWebsite(this.props.selectedWebsiteUrl);
  }

  render() {
    return (
      <RemoveUrlTab
        isDeleting={this.props.isDeleting}
        removeTrackedWebsite={this.removeTrackedWebsite}
        selectedWebsiteUrl={this.props.selectedWebsiteUrl}
      />
    );
  }
}

const mapStateToProps = state => ({
  isDeleting: isDeletingTrackedWebsite(state, getSelectedWebsiteUrl(state)),
  selectedWebsiteUrl: getSelectedWebsiteUrl(state)
});

export default connect(mapStateToProps, { deleteTrackedWebsite })(RemoveUrl);
